import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, HStack, Text } from '@chakra-ui/react';

import { triggerAutomation } from '../../../../api/portal-api';
import { analyticsIds } from '../../../../constants/analyticsIds';
import { EmailAutomationPanelDuskIds } from '../../../../constants/duskIds';
import { selectCurrentAutomation } from '../../../../redux/modules/emailAutomations';
import { createToast } from '../../../../utils/toastUtil';

const AutomationTabHeader = () => {
  const currentAutomation = useSelector(selectCurrentAutomation);

  if (!currentAutomation) return null;

  const handleTriggerAutomationClick = async () => {
    try {
      await triggerAutomation(currentAutomation.id);
      createToast({ title: 'Automation Triggered Successfully', status: 'success' });
    } catch (e) {
      createToast({ title: 'Error triggering Automation', status: 'error', description: e.message });
    }
  };

  return (
    <HStack justifyContent="space-between" w="100%">
      <Box textAlign="left">
        <Text
          color="primaryScale.600"
          data-analytics-id={analyticsIds.emailAutomations.emailAutomationSettingsHeader}
          dusk={EmailAutomationPanelDuskIds.emailAutomationSettingsHeader(currentAutomation?.id)}
          maxW="400px"
          textAlign="left"
          textStyle="displayXs"
        >
          {currentAutomation?.name}
        </Text>

        { currentAutomation.description && (
        <Text color="gray.500" mt={2}>
          {currentAutomation.description}
        </Text>
        )}
      </Box>

      {PINS_ENV !== 'prod' && (
        <Button variant="primaryCaution" onClick={handleTriggerAutomationClick}>Trigger Automation</Button>
      )}
    </HStack>
  );
};

AutomationTabHeader.propTypes = {};

export default AutomationTabHeader;
